// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__GpZWP","orange":"Tag_orange__CdMkE","green":"Tag_green__TLJqQ","red":"Tag_red__1gEBK"};